import {
  LinePriceCell,
  type PurchaseIntentPriceLineItem,
  resolveLinePrice,
} from "@/features/shared/checkout-summary";

type LineItemCardProps = {
  lineItem: PurchaseIntentPriceLineItem;
  /**
   * Overrides the "Billed monthly / annually" caption on a recurring line. The presale
   * cart says "Billed monthly from <launch date>" — the same cadence, starting on a date
   * only that campaign knows.
   */
  recurringCaption?: string;
};

export const LineItemCard = ({
  lineItem,
  recurringCaption,
}: LineItemCardProps) => {
  const isOneTime = lineItem.type !== "recurring";

  // The discount caption this row used to carry ("<code> (-100% off)") announced a
  // reduction the price never showed — and rendered with an empty code, because the
  // server sends no promotion code on a line discount. The struck-through price says
  // it now, and the ledger's own Offer discount row says what it is worth.
  const price = resolveLinePrice({
    totalCents: lineItem.total ?? 0,
    discountCents: lineItem.discount?.amount ?? 0,
    totalLabel: lineItem.totalLabel ?? "",
    discountedLabel: lineItem.discount?.discountedLabel ?? "",
    isOneTime,
  });

  return (
    <div className="flex justify-between gap-2 py-2">
      <div className="space-y-1">
        <div className="text-sm leading-5 font-medium">{lineItem.name}</div>
        <p className="text-xs leading-4 text-text-dark-low">
          {isOneTime
            ? "One-time payment"
            : (recurringCaption ??
              `Billed ${lineItem.recurring === "monthly" ? "monthly" : "annually"}`)}
        </p>
      </div>
      <LinePriceCell price={price} className="shrink-0" />
    </div>
  );
};
